import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState({});
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        api.get("/content")
            .then((r) => setContent(r.data || {}))
            .catch(() => {})
            .finally(() => setLoaded(true));
    }, []);

    const c = useCallback(
        (key, fallback = "") => {
            const v = content[key];
            return v === undefined || v === null ? fallback : v;
        },
        [content]
    );

    const saveContent = useCallback(async (key, value) => {
        // optimistic update
        setContent((prev) => ({ ...prev, [key]: value }));
        try {
            await api.patch("/admin/content", { key, value });
            return true;
        } catch (err) {
            // revert on failure — refetch
            try {
                const { data } = await api.get("/content");
                setContent(data || {});
            } catch {}
            throw err;
        }
    }, []);

    return (
        <ContentContext.Provider value={{ content, c, saveContent, loaded }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContentApi = () => {
    const ctx = useContext(ContentContext);
    if (!ctx) throw new Error("useContentApi inside ContentProvider");
    return ctx;
};
